import { Component, HostListener, Input, OnInit } from '@angular/core'
import { Store, select } from '@ngrx/store'
import { Destroyable } from '@tokeet-frontend/tv3-platform'
import { FetchGuests } from '@tv3/store/guest/guest.actions'
import { selectGuestById } from '@tv3/store/guest/guest.selectors'
import { OpenGuestOverlay } from '@tv3/store/overlay/overlay.actions'
import { BehaviorSubject } from 'rxjs'
import { filter, switchMap, tap } from 'rxjs/operators'

@Component({
  selector: 'app-guest-name',
  templateUrl: './guest-name.component.html',
  styleUrls: ['./guest-name.component.scss'],
})
export class GuestNameComponent extends Destroyable implements OnInit {
  guestId$ = new BehaviorSubject<string>('')

  @Input() set guestId(guestId: string) {
    if (guestId !== this.guestId$.value) this.guestId$.next(guestId)
  }
  get guestId() {
    return this.guestId$.value
  }

  @Input() secondaryLabel = ''
  @Input() image = false
  @Input() imageSize: number = 25
  @Input() imageCircle = false
  @Input() clickable = false

  @Input() tooltipDisabled = false

  guest$ = this.guestId$.pipe(
    filter((guestId) => !!guestId),
    switchMap((guestId) => this.store.pipe(select(selectGuestById, { id: guestId }))),
    tap((guest) => {
      if (!guest) this.store.dispatch(FetchGuests({ ids: [this.guestId$.value] }))
    })
  )

  constructor(private store: Store<any>) {
    super()
  }

  ngOnInit(): void {}

  @HostListener('click')
  onClick() {
    if (!this.clickable) return
    this.store.dispatch(OpenGuestOverlay({ guestId: this.guestId$.value }))
  }
}
